import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SnapshotAlarmGroup } from 'types';

export const getAlarmSnapshotGroups = async ({
  alarmId,
}: {
  alarmId: number;
}): Promise<SnapshotAlarmGroup[]> => {
  const { data } = await axios.get(`/api/snapshots/alarms/${alarmId}/groups`);
  return data as SnapshotAlarmGroup[];
};

type QueryFnType = typeof getAlarmSnapshotGroups;

type UseAlarmOptions = {
  alarmId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSnapshotAlarmGroups = ({
  alarmId,
  config,
}: UseAlarmOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['alarms', alarmId, 'groups'],
    queryFn: () => getAlarmSnapshotGroups({ alarmId }),
    ...config,
  });
};
